import {
  ShouldPushToDataLayerObject,
  TrackingClientStateHolder,
} from '@aboutyou/legacy-tracking-sdk';
import {exists} from '@aboutyou/utils';
import {useOriginClick} from './getOriginClick';
import {useTracking} from './utils';

export type TrackingFunction<FirstArgument, MapTrackingData> = (
  arg: {
    type: FirstArgument;
  } & MapTrackingData,
) => (state: TrackingClientStateHolder) => ShouldPushToDataLayerObject;

export function useTrackingFactory<FirstArgument, MapTrackingData>(
  mapTrackingData: () => MapTrackingData,
  trackInteractionFunction: TrackingFunction<FirstArgument, MapTrackingData>,
) {
  const {TrackingClient, pageContextCallback} = useTracking();
  const trackOriginClick = useOriginClick();

  return (type: FirstArgument): boolean => {
    const pageContext = pageContextCallback();
    if (exists(pageContext) && exists(mapTrackingData)) {
      TrackingClient.track(
        trackInteractionFunction({
          type,
          ...mapTrackingData(),
        }),
      );

      trackOriginClick(type, mapTrackingData());
      return true;
    }

    if (!exists(pageContext) || !exists(mapTrackingData)) {
      throw new Error(
        `pageContext is ${
          exists(pageContext) ? 'available' : 'not available'
        } \n mapTrackingData is ${
          exists(mapTrackingData) ? 'available' : 'not available'
        }`,
      );
    }

    return false;
  };
}
